/**
 * Shared API client utilities for making authenticated requests.
 */
import { getIdToken } from './cognito-client';

export const API_BASE_URL = import.meta.env.VITE_API_URL ?? '';

/**
 * Get headers for authenticated API requests.
 * Uses the ID token for API Gateway Cognito authorizer.
 */
export async function getAuthHeaders(): Promise<Record<string, string>> {
  const token = await getIdToken();
  
  if (token) {
    console.log('[API Client] Token retrieved, length:', token.length);
  } else {
    console.warn('[API Client] No token available - request will be unauthenticated');
  }
  
  // API Gateway Cognito authorizer expects the raw token, not "Bearer <token>"
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  
  if (token) {
    headers.Authorization = token;
  }
  
  return headers;
}

/**
 * Make an authenticated GET request.
 */
export async function authFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const headers = await getAuthHeaders();
  return fetch(url, {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
  });
}

/**
 * Build a URL with query parameters.
 */
export function buildApiUrl(path: string, params?: URLSearchParams): string {
  const queryString = params?.toString();
  const basePath = `${API_BASE_URL}${path}`;
  return queryString ? `${basePath}?${queryString}` : basePath;
}
